// extracted by mini-css-extract-plugin
export var FloatingNav = "FloatingNavigation-module--FloatingNav--1e32a";
export var FloatingNavButton = "FloatingNavigation-module--FloatingNavButton--7c5c9";
export var FloatingNavTransitionEnter = "FloatingNavigation-module--FloatingNavTransitionEnter--be69d";
export var FloatingNavTransitionEnterActive = "FloatingNavigation-module--FloatingNavTransitionEnterActive--c5088";
export var FloatingNavTransitionExit = "FloatingNavigation-module--FloatingNavTransitionExit--e6c75";
export var FloatingNavTransitionExitActive = "FloatingNavigation-module--FloatingNavTransitionExitActive--e9106";